var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.357C7.675 5.357 6.6 4.302 6.6 3H3.4v3.143C2.075 6.143 1 7.198 1 8.5c0 1.302 1.075 2.357 2.4 2.357V14h3.2c0-1.302 1.075-2.357 2.4-2.357s2.4 1.055 2.4 2.357h3.2v-3.143c1.325 0 2.4-1.055 2.4-2.357 0-1.302-1.075-2.357-2.4-2.357V3h-3.2c0 1.302-1.075 2.357-2.4 2.357z",
    stroke: "currentColor",
    strokeWidth: 0.96,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapability);
export default __webpack_public_path__ + "static/media/capability.c4375b32d19f1bddf9e4e850a57bdeee.svg";
export { ForwardRef as ReactComponent };